var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.546,
    height: 37.523,
    viewBox: "0 0 41.546 37.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44585",
    "data-name": "Path 44585",
    d: "M9.908,0a10.172,10.172,0,0,1,7.909,3.762,10.194,10.194,0,0,0,1.126,1.512.965.965,0,0,0,.807-.089c.185-.147.731-1.117.975-1.424A9.741,9.741,0,0,1,35.753,3.4c5.485,6.165,1.914,14.675-2.7,20.156A51.572,51.572,0,0,1,19.37,34.478l-.255-.028C10.948,29.729.475,21.379.01,11.233-.243,5.691,4.034.086,9.908,0",
    transform: "translate(1.502 1.501)",
    fill: "none",
    stroke: "#111",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heart_outline.54f66a912e104654ca45684044862da6.svg";
export { ForwardRef as ReactComponent };